<app-enfaf-modal
  (onClose)="confirmCloseModal()"
  buttonCancelText="Cancelar"
  buttonConfirmText="Guardar"
  (onConfirm)="saveProduct()"
  [isLoading]="isSavingProduct"
  [disableConfirmButton]="shouldDisableConfirmButton"
  svgIcon="shopping-cart"
  title="Editar producto"
>
  <form [formGroup]="productForm" class="product-form">
    <div class="product-form-content">
      <div class="form-row main-row">
        <div class="form-control image-control">
          <app-enfaf-img-dragger
            [urlImage]="productForm.value.productImageUrl"
            (onImageUpload)="uploadImage($event)"
            (onImageDelete)="deleteImage()"
            title="Imagen del producto"
            subtitle="Subir imagen"
          ></app-enfaf-img-dragger>
        </div>
        <div class="form-control fields-control">
          <!-- Nombre del producto -->
          <div class="field-wrapper">
            <enfaf-input
              label="Nombre del producto"
              placeholder="Nombre del producto"
              [control]="productForm.get('name')"
              name="productName"
              autocomplete="off"
              [errorLabel]="nameErrors || ''"
              color="light"
            >
            </enfaf-input>
          </div>

          <!-- Precio e IVA en la misma fila -->
          <div class="price-iva-row">
            <div class="field-wrapper">
              <enfaf-input-suffix
                label="Precio"
                type="number"
                placeholder="Precio"
                [control]="productForm.get('price')"
                step="1"
                min="0"
                max="10000"
                suffixIcon="euro-sign"
                description="Si quieres un producto gratuito, digita 0"
                name="price"
                iconSize="'21px"
                autocomplete="off"
                color="light"
                [errorLabel]="priceErrors || ''"
              >
              </enfaf-input-suffix>
            </div>

            <div class="field-wrapper">
              <enfaf-input-suffix
                label="IVA"
                type="number"
                placeholder="IVA"
                [control]="productForm.get('iva')"
                step="1"
                min="0"
                max="100"
                iconSize="'21px'"
                suffixIcon="percent"
                description="Mín 0 - Máx 100 (Si no tiene IVA, pon 0)"
                name="iva"
                autocomplete="off"
                color="light"
                [errorLabel]="ivaErrors || ''"
              >
              </enfaf-input-suffix>
            </div>
          </div>
        </div>
      </div>

      <div class="form-row">
        <div class="chekbox-group">
          <app-enfaf-checkbox color="light" [control]="productForm.controls.hasReducedFields"
            >Solicitar campos reducidos en el registro</app-enfaf-checkbox
          >
          <app-enfaf-icon
            matTooltip="Marca esta casilla si quieres reducir el número de campos que se solicitan al usuario durante el registro/compra de este curso"
            matTooltipClass="chekbox-group-tooltip"
            matTooltipPosition="above"
            svgIconName="info-dark"
            iconSize="24px"
          ></app-enfaf-icon>
        </div>
      </div>

      @if (hasReducedFields) {
        <div class="form-row">
          <app-enfaf-textarea-light
            label="Descripción"
            placeholder="Descripción"
            [control]="productForm.controls.reducedFieldsDescription"
            name="reducedFieldsDescription"
            color="light"
            description="Añade una descripción complementaria en el checkout con campos reducidos"
          >
          </app-enfaf-textarea-light>
        </div>
      }

      <!-- Segunda fila: SKU y Curso -->
      <div class="form-row">
        <div class="form-control">
          <enfaf-input
            label="SKU"
            placeholder="SKU"
            [control]="productForm.get('sku')"
            name="sku"
            autocomplete="off"
            [errorLabel]="skuErrors || ''"
            description="EL_FORMATO_ES_ASI"
            color="light"
          >
          </enfaf-input>
        </div>
      </div>

      <!-- Cursos a vender -->
      <div class="form-row">
        <div class="form-control-courses">
          <div class="courses-content">
            <div>Cursos a vender:</div>
            <enfaf-multi-autocomplete-light
              #coursesAutocomplete
              placeholder="Buscar"
              [fetchData]="fetchCourses"
              [selectedOptions]="selectedCourses"
              (selectedChanged)="onSelectedCoursesChanged($event)"
            >
            </enfaf-multi-autocomplete-light>
            @if (selectedCourses.length > 0) {
              <div class="selected-courses-list">
                @for (course of selectedCourses; track $index) {
                  <div class="course-item">
                    <span class="course-name">{{ course.title }}</span>
                    <app-enfaf-icon
                      [svgIconName]="'trash-red'"
                      [iconSize]="'16px'"
                      [iconStyle]="{ color: '#E03131' }"
                      [isButton]="true"
                      (onClick)="removeCourse(course.id)"
                      class="remove-icon"
                    >
                    </app-enfaf-icon>
                  </div>
                }
              </div>
            } @else {
              <div class="not-courses">Si no añades ningún curso el producto se podrá comprar pero no quedará vinculado a ningún curso. </div>
            }
          </div>
        </div>
      </div>

      <!-- Tercera fila: URLs -->
      <div class="form-row row-urls">
        <div class="form-control">
          <enfaf-input
            label="URL de redirección"
            placeholder="URL de redirección"
            [control]="productForm.get('redirectUrl')"
            name="redirectUrl"
            type="url"
            autocomplete="off"
            [errorLabel]="redirectUrlErrors || ''"
            description="Dejar este campo vacío si no quieren redirigir a ninguna página externa, solo al login."
            color="light"
          >
          </enfaf-input>
        </div>

        <div class="form-control">
          <enfaf-input
            label="URL de callback"
            placeholder="URL de callback"
            [control]="productForm.get('urlGoogleSheets')"
            name="urlGoogleSheets"
            type="url"
            autocomplete="off"
            [errorLabel]="urlGoogleSheetsErrors || ''"
            description="Los datos de los alumnos que compren el producto se registrarán en esta página"
            color="light"
          >
          </enfaf-input>
        </div>
      </div>

      <!-- Sección de variantes -->
      <app-product-variants [parentForm]="productForm" [variants]="variants" (variantsChange)="onVariantsChange($event)"> </app-product-variants>

      <!-- Contrato adjunto -->
      <div class="form-section">
        <h3 class="section-title">Adjunta el contrato de este producto (PDF)</h3>
        <div class="upload-zone">
          <app-enfaf-input-file-dragger-light
            [acceptMultiple]="false"
            [acceptLimit]="1"
            [maxFileSize]="25000000"
            [accept]="'application/pdf'"
            [currentFiles]="getAgreementFiles()"
            [localFiles]="getLocalAgreementFiles()"
            (localFileDeleted)="deleteAgreementFile($event)"
            (currentFileDeleted)="onDeleteRemoteAgreementAttachment($event)"
            (filesDropped)="onDroppedFiles($event)"
          >
          </app-enfaf-input-file-dragger-light>
        </div>
      </div>

      <!-- Nota para precio cero -->
      @if (productForm.value.price === 0) {
        <div class="zero-price-note">
          <mat-icon color="warn">info</mat-icon>
          <span>Si el precio es CERO, no puedes modificar nada con respecto a la suscripción</span>
        </div>
      }

      <!-- Toggle de suscripción - disponible tanto en creación como edición -->
      <div class="form-row subscription-toggle">
        <div class="form-control subscription-control">
          <app-enfaf-switch-dark
            [control]="productForm.get('isSubscription')!"
            label="Este producto es una suscripción"
            [disabled]="productForm.value.price === 0"
            color="light"
          >
          </app-enfaf-switch-dark>
        </div>
      </div>
    </div>

    <!-- Campos de suscripción (visibles si isSubscription es true) -->
    @if (productForm.value.isSubscription && productForm.value.price !== 0) {
      <div class="subscription-fields">
        <h3 class="subscription-title">Datos de la suscripción</h3>

        <div class="subscription-form">
          <!-- Frecuencia y Granularidad -->
          <div class="form-row">
            <div class="form-control">
              <enfaf-input
                label="Frecuencia de cobro"
                placeholder="Frecuencia"
                [control]="productForm.get('frequency')"
                name="frequency"
                type="number"
                min="1"
                max="12"
                step="1"
                autocomplete="off"
                [errorLabel]="frequencyErrors || ''"
                color="light"
              >
              </enfaf-input>
            </div>

            <div class="form-control">
              <enfaf-select-light
                label="Recurrencia"
                placeholder="Selecciona recurrencia"
                [control]="productForm.get('frequencyGranularity')"
                name="frequencyGranularity"
                [options]="[
                  { value: 'DAY', viewValue: 'Días' },
                  { value: 'WEEK', viewValue: 'Semanas' },
                  { value: 'MONTH', viewValue: 'Meses' },
                  { value: 'YEAR', viewValue: 'Años' }
                ]"
                [errorLabel]="frequencyGranularityErrors || ''"
                color="light"
              >
              </enfaf-select-light>
            </div>
          </div>

          <!-- Número de ciclos y Costo de inscripción -->
          <div class="form-row">
            <div class="form-control">
              <enfaf-input
                label="Número de ciclos"
                placeholder="Número de ciclos"
                [control]="productForm.get('totalCycles')"
                name="totalCycles"
                type="number"
                min="1"
                max="999"
                step="1"
                autocomplete="off"
                [errorLabel]="totalCyclesErrors || ''"
                color="light"
              >
              </enfaf-input>
            </div>

            <div class="form-control">
              <enfaf-input-suffix
                label="Costo de la inscripción"
                type="number"
                placeholder="Costo de la inscripción"
                [control]="productForm.get('signUpFee')"
                name="signUpFee"
                autocomplete="off"
                min="0"
                max="10000"
                step="0.01"
                suffixIcon="euro-sign"
                iconSize="'21px'"
                [errorLabel]="signUpFeeErrors || ''"
                color="light"
              >
              </enfaf-input-suffix>
            </div>
          </div>
        </div>
      </div>
    }
  </form>
</app-enfaf-modal>
